import React from 'react';

import { ReactComponent as BackgroundShape } from '../../../assets/svg/FBQA_backgroundshape.svg';
import { ReactComponent as LogoImg } from '../../../assets/svg/logo_MIAuto_VerticalOnWhite.svg';
import ShadowImg from '../../../assets/images/FBQA_shadow.png';

import './logo.scss';

const Logo = ({ interstitial }) => {
  return (
    <div className={`col-lg-3 ${interstitial ? 'col-offset-md-01' : 'col-offset-md-1'}`}>
      <div className="c-logo">
        <BackgroundShape className="c-logo--background" />
        <img src={ShadowImg} alt="shadow" className="c-logo--shadow" />
        <LogoImg className="c-logo--image" />
      </div>
    </div>
  );
};

export default Logo;
